import { Controller } from "@hotwired/stimulus"

// contribution-direction — toggle Guardar/Retirar do form de movimentação da meta.
// O usuário sempre digita valor POSITIVO; este controller só alterna a direção
// (deposit/withdraw) num hidden field e ajusta a apresentação (prefixo +/−,
// cor e rótulo do botão). O SINAL de fato é aplicado no servidor a partir do
// hidden `direction` — o cliente nunca é fonte de verdade. CSP-safe.
//
// Uso: data-controller="contribution-direction" com:
//   - botões do segmented: data-action="contribution-direction#pick" data-direction="deposit|withdraw"
//   - hidden field:        data-contribution-direction-target="input"
//   - prefixo do valor:    data-contribution-direction-target="prefix"
//   - botão submit:        data-contribution-direction-target="submit"
//   - values: depositLabel/withdrawLabel (rótulos do botão submit)
export default class extends Controller {
  static targets = ["input", "prefix", "submit", "button"]
  static values = { depositLabel: String, withdrawLabel: String }

  connect() {
    this._apply(this.hasInputTarget ? (this.inputTarget.value || "deposit") : "deposit")
  }

  pick(event) {
    const dir = event.currentTarget.dataset.direction === "withdraw" ? "withdraw" : "deposit"
    this._apply(dir)
  }

  _apply(dir) {
    const withdraw = dir === "withdraw"
    if (this.hasInputTarget) this.inputTarget.value = dir

    // Segmented: marca o botão ativo com a classe de sinal correspondente.
    this.buttonTargets.forEach((b) => {
      const on = (b.dataset.direction || "deposit") === dir
      b.classList.toggle("bg-positive/12", on && !withdraw)
      b.classList.toggle("text-positive", on && !withdraw)
      b.classList.toggle("bg-negative/12", on && withdraw)
      b.classList.toggle("text-negative", on && withdraw)
      b.classList.toggle("text-muted-foreground", !on)
    })

    if (this.hasPrefixTarget) {
      this.prefixTarget.textContent = withdraw ? "−" : "+"
      this.prefixTarget.classList.toggle("text-negative", withdraw)
      this.prefixTarget.classList.toggle("text-positive", !withdraw)
    }

    if (this.hasSubmitTarget) {
      const label = withdraw ? this.withdrawLabelValue : this.depositLabelValue
      const labelEl = this.submitTarget.querySelector("[data-label]")
      if (labelEl) labelEl.textContent = label
      // Botão verde (guardar) vs. vermelho-outline (retirar).
      this.submitTarget.classList.toggle("bg-primary", !withdraw)
      this.submitTarget.classList.toggle("text-primary-foreground", !withdraw)
      this.submitTarget.classList.toggle("border-negative/40", withdraw)
      this.submitTarget.classList.toggle("text-negative", withdraw)
      this.submitTarget.classList.toggle("bg-transparent", withdraw)
    }
  }
}
